import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMenu, FiX, FiPhone } from 'react-icons/fi';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location]);

  const navLinks = [
    { name: 'Startseite', path: '/' },
    { name: 'Leistungen', path: '/leistungen' },
    { name: 'Bauen in Eigenleistung', path: '/eigenleistung' },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${
        isScrolled ? 'shadow-md py-3' : 'py-5'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center group">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/b3858647681825aecd68df56d8217cb5094538977d896e84f508e759d2eeedf7b0dda9d7934361b5765cf6718803dd25/images/aW1hZ2UvcG5n/34b46cb221730d0e79867cbaafd25717.png" 
            alt="Kittsteiner Hoch-Tiefbau GmbH Logo" 
            className="h-12 md:h-16 w-auto object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden xl:flex items-center gap-8">
          <div className="flex items-center gap-6">
            {navLinks.map((link) => (
              <NavLink 
                key={link.name} 
                to={link.path} 
                className={({ isActive }) => 
                  `text-xs xl:text-sm font-semibold uppercase tracking-wider transition-colors hover:text-red-800 whitespace-nowrap ${
                    isActive ? 'text-red-800' : 'text-slate-600'
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
          </div>
          
          <div className="flex items-center gap-4 border-l border-slate-200 pl-6">
            <a 
              href="tel:015174465832" 
              className="flex items-center gap-2 bg-slate-100 text-slate-800 px-4 py-2 rounded font-medium hover:bg-slate-200 transition-colors text-sm"
            >
              <SafeIcon icon={FiPhone} className="text-sm text-red-800" />
              0151 / 744 658 32
            </a>
            <Link 
              to="/kontakt" 
              className="bg-red-800 text-white px-5 py-2 rounded font-medium hover:bg-red-900 transition-colors text-sm uppercase tracking-wider"
            >
              Kontakt
            </Link>
          </div>
        </nav>

        {/* Mobile Menu Toggle */}
        <button 
          className="xl:hidden text-slate-800 p-2 focus:outline-none"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-2xl" />
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="xl:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t border-slate-100 py-6 px-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <NavLink 
              key={link.name} 
              to={link.path} 
              className={({ isActive }) => 
                `text-base font-semibold uppercase tracking-wider py-2 border-b border-slate-100 ${
                  isActive ? 'text-red-800' : 'text-slate-700'
                }`
              }
            >
              {link.name}
            </NavLink>
          ))}
          <a 
            href="tel:015174465832" 
            className="flex items-center justify-center gap-2 bg-slate-100 text-slate-800 px-4 py-3 rounded font-medium mt-2"
          >
            <SafeIcon icon={FiPhone} className="text-red-800" />
            0151 / 744 658 32
          </a>
          <Link 
            to="/kontakt" 
            className="flex items-center justify-center bg-red-800 text-white px-4 py-3 rounded font-bold uppercase tracking-wider"
          >
            Kontakt
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;